import React, { useState, useEffect } from 'react';

function HeaderSelector({ headers, uniquekey, onSelect, selectedFromConfig }) {
  const [selectedHeader, setSelectedHeader] = useState(null);

  const handleSelectionChange = (event) => {
    setSelectedHeader(event.target.value);
    onSelect(event.target.value);
  };

  useEffect(() => {
    setSelectedHeader(selectedFromConfig);
  }, [selectedFromConfig]);

  return (
    <div>
      {headers.map((header) =>
        header === '' ? null : (
          <React.Fragment key={`${header}-${uniquekey}`}>
            <label>
              <input
                type="radio"
                value={header}
                name={`group-${uniquekey}`}
                checked={selectedHeader === header}
                onChange={handleSelectionChange}
              />
              {header}
            </label>
            <br />
          </React.Fragment>
        ),
      )}
    </div>
  );
}

export default HeaderSelector;
